import styled from "styled-components";

export const HeaderContainer = styled.header`
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 70px;
    position: fixed;
    background: white;
    width: 100%;
    bottom: -1px;
    z-index: 9;

    &.header-top {
        bottom: unset;
    }


    .component-3, .component-4{
        display: block;
    }

    .component-0, .component-4{
        .property-search-actions {
            display: block;
        }
    }

    .component-2, .component-5{
        display: none;
    }

    @media (min-width: 992px) {
        bottom: unset;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 4px;
        margin-bottom: 10px;
        height: 100px;

        .component-3, .component-4{
            display: none;
        }
        .component-0, .component-4{
            .property-search-actions {
                display: none;
            }
        }
        .component-5{
            display: block;

            .cmp-image{
                width: 222px;
                height: 80px;
                margin-right: 20px;
                display: contents;

                .cmp-image__link > .cmp-image__image {
                    width: 210px;
                    height: 80px;
                }
            }
        }
        .component-2{
            display: block;
        }
    }

    .component-1{
        flex: 1 1 100%;
        @media (min-width: 992px) {
            flex: unset;
        }
        .cmp-image{
            width: 85px;
            margin: 0 0 0 20px;

            .cmp-image__image {
                width: 85px;
                height: 25px;
            }

            @media (min-width: 992px) {
                width: 112px;
                margin: 0  0 0 25px;

                .cmp-image__image {
                    width: 112px;
                    height: 33px;
                }
            }
        }

    }
    .component-2{
        div:nth-child(1){
            width: 100%;
        }
    }

    @media (min-width: 992px) {
        .component-2{
            display: flex;
            width: 60%;
            justify-content: center;
            .style-button{
                padding: 0;
            }
            .property-search-container {
                .property-search-content {
                    width: 100%;
                }
                .property-search-actions {
                    .form-group {
                        justify-content: center;
                    }
                    .form-label {
                        display: none;
                    }
                    .custom-button {
                        margin: 0;
                        height: 49px !important;
                        width: auto !important;
                        padding: 12px !important;
                    }

                    .property-search-form {
                        margin-top: 0px;
                        align-items: center;

                        .defaultFullWidth {
                            width: 100%;
                            background-color: #079d56
                            color: rgb(255, 255, 255);

                            &:disabled {
                                background-color: rgb(217, 221, 219);
                                color: rgb(153, 158, 156);
                                cursor: not-allowed;
                            }
                        }
                    }
                }
            }            
        }
    }

 

`;
